import { createContext } from 'react';
import { ControlledRenderOptions } from '../types';

export const ControlledRenderOptionsContext = createContext<ControlledRenderOptions>({});
